import {Component, Input, OnInit} from '@angular/core';
import {Issue} from '../../../models/issue';

@Component({
  selector: 'app-sp2-drag-preview',
  templateUrl: './sp2-drag-preview.component.html',
  styleUrls: ['./sp2-drag-preview.component.scss']
  })
export class Sp2DragPreviewComponent implements OnInit {
  @Input() public issue: Issue;
  @Input() public type: string;

  public cdkDragPreviewClass: string;

  constructor() {
  }

  ngOnInit(): void {
    this.cdkDragPreviewClass = 'cdk-drag-preview_' + this.type;
  }

}
